import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'priceInCents',
  pure: false
})
export class PriceInCentsPipe implements PipeTransform {
  constructor() {}

  transform (value: number = 0) {
    return Math.ceil(parseInt((value * 100).toFixed(0), 0));
  }
}
